
import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import NavigationItems from './NavigationItems';
import HeaderActions from './HeaderActions';
import MobileMenu from './MobileMenu';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    { 
      name: 'Servers', 
      href: '#', 
      hasDropdown: true,
      subItems: [
        { name: 'Baremetal Servers', href: '/baremetal-servers' },
        { name: 'Virtual Private Servers', href: '/vps-servers' },
        { name: 'Residential Remote Desktops', href: '/residential-remote-desktops' }
      ]
    },
    { name: 'Colocation', href: '#colocation', isNcolo: true },
    { name: 'Residential Proxies', href: '/residential-proxies' },
    { name: 'Mobile Solutions', href: '/mobile-solutions' },
    { name: 'Brokerage', href: '/brokerage' },
    { name: 'Consultation', href: '/consultation' },
  ];

  const handleNavClick = (item: typeof navItems[0]) => {
    if (item.isNcolo) {
      window.open('https://ncolo.net', '_blank');
      return;
    }
    
    if (item.href.startsWith('/')) {
      // React Router will handle this
      return;
    }
    
    // Handle anchor links
    window.location.href = item.href;
  };

  const handleScheduleClick = () => {
    // This function is kept for compatibility but the actual logic is now in the components
    console.log('Schedule meeting clicked');
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex items-center">
            <Link to="/">
              <img 
                src="/lovable-uploads/52ecf367-6211-48aa-82c5-83c88558cc42.png" 
                alt="NEXX"
                className="h-10 w-auto"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <NavigationItems navItems={navItems} onNavClick={handleNavClick} />

          {/* CTA Buttons */}
          <HeaderActions onScheduleClick={handleScheduleClick} />

          {/* Mobile menu button */}
          <div className="lg:hidden">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label={isMenuOpen ? "Close menu" : "Open menu"}
              aria-expanded={isMenuOpen}
              aria-controls="mobile-menu"
            >
              {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        <MobileMenu 
          isOpen={isMenuOpen}
          navItems={navItems}
          onNavClick={handleNavClick}
          onScheduleClick={handleScheduleClick}
          onClose={() => setIsMenuOpen(false)}
        />
      </div>
    </header>
  );
};

export default Header;
